import { c as _c } from "react/compiler-runtime";
import { MdrtLogo } from '@shared/ui-components/svgs';
import styles from './loader-spinner.module.scss';
export const LoaderSpinner = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MdrtLogo className={styles["loader-logo"]} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<div className={styles["loader-spinner"]}><svg viewBox="22 22 44 44"><circle cx="44" cy="44" fill="none" r="20" strokeWidth="2" /></svg></div></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};